import React from 'react';
import { Form, Icon, Message, Divider } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../components/funcionales/estaseguro'

const DetalleNivel1 = props => {
  let apiSAE='No aplica'
  let isoGr='No aplica'
  let isoGrColor='No aplica'
  let isoGrTexto='No aplica'
  if(props.elemento.tipoGrado==='SAE'){
    apiSAE=props.elemento.apiSAE
  }else{
    if(props.elemento.tipoGrado==='NLGI'){
      isoGr=props.elemento.isoGrasa
      isoGrColor=props.elemento.isoGrasaColor
      isoGrTexto=props.elemento.isoGrasaTexto
    }
  }
  return (
    <option dato1={props.elemento.tipoLub} dato2={props.elemento.descrFabricante} dato3={props.elemento.categoriaLub}
     dato4={props.elemento.tipoGrado} dato5={props.elemento.descrGrado} dato6={props.elemento.colorGrado} 
     dato7={apiSAE} dato8={isoGr} dato9={isoGrColor} dato10={isoGrTexto}>
     {props.elemento.descrLubricante}
    </option>
  )
  };
  
const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrLubricante" id="miLista1" value={permiteUpdate?argsDocum.descrLubricante:idLista.descrLubricante?idLista.descrLubricante:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel1Detalle}
      </select>
    </div>
  )
};
const DetalleNivel2 = props => {
  return (
    <option dato1={props.elemento.color}>{props.elemento.descrAplicacion}</option>
  )
  };
  
const ListaAp = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrAplicacion" id="miLista2" value={permiteUpdate?argsDocum.descrAplicacion:idLista.descrAplicacion?idLista.descrAplicacion:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel2Detalle}
      </select>
    </div>
  )
};

const ListaTF = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoFrecuencia" id="miLista4" value={permiteUpdate?argsDocum.tipoFrecuencia:idLista.tipoFrecuencia} onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Calendario</option>
        <option>Horas</option>
        <option>Km</option>
      </select>
    </div>
  )
};

const DetalleNivel3 = props => {
  return (
    <option dato1={props.elemento.abrevUnidad}>{props.elemento.descrUnidad}</option>
  )
  };
  
const ListaU = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel3Detalle = list.map((elemento, _id) => <DetalleNivel3 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrUnidad" id="miLista3" value={permiteUpdate?argsDocum.descrUnidad:idLista.descrUnidad?idLista.descrUnidad:"Seleccionar..."} onChange={(ev)=>handleChange(ev, argsDocum)}>
          <option value="">Seleccionar...</option>
          {Nivel3Detalle}
      </select>
    </div>
  )
};

class VerPr2 extends React.Component {
  state={
    argsDocum: {codPlanta: this.props.idLista.codPlanta, descrPlanta: this.props.idLista.descrPlanta,
                codSeccion: this.props.idLista.codSeccion, descrSeccion: this.props.idLista.descrSeccion,
                codEquipo: this.props.idLista.codEquipo, descrEquipo: this.props.idLista.descrEquipo,
                codComponente: this.props.idLista.codComponente, descrComponente: this.props.idLista.descrComponente,
                codMecanismo: this.props.idLista.codMecanismo, descrMecanismo: this.props.idLista.descrMecanismo,
                descrLubricante: this.props.idLista.descrLubricante,
                descrAplicacion: this.props.idLista.descrAplicacion, tipoFrecuencia: this.props.idLista.tipoFrecuencia,
                cantidadTotal: this.props.idLista.cantidadTotal,
                descrUnidad: this.props.idLista.descrUnidad,
                descrEmpresa: this.props.idLista.descrEmpresa,
                _id: this.props.idLista.idPlanta},
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
        const argsDocum = this.state.argsDocum
        argsDocum[ev.target.name] = ev.target.value 
        this.setState({argsDocum});
    }
  }

  handleQuestionUpdDel = async (ev) => { 
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){
      this.setState({open: true})}else{this.setState({open: false})
    };
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }
  
  render(){
    const {argsDocum, open, confirmaAct} = this.state;

    let descrPlantaAnt = this.props.idLista.descrPlanta
    let descrSeccionAnt = this.props.idLista.descrSeccion
    let descrEquipoAnt = this.props.idLista.descrEquipo
    let descrComponenteAnt = this.props.idLista.descrComponente
    let descrMecanismoAnt = this.props.idLista.descrMecanismo
    let codPlantaAnt = this.props.idLista.codPlanta
    let codSeccionAnt = this.props.idLista.codSeccion
    let codEquipoAnt = this.props.idLista.codEquipo
    let codComponenteAnt = this.props.idLista.codComponente
    let codMecanismoAnt = this.props.idLista.codMecanismo
    let descrLubricanteAnt = this.props.idLista.descrLubricante
    let descrAplicacionAnt = this.props.idLista.descrAplicacion
    let tipoFrecuenciaAnt = this.props.idLista.tipoFrecuencia
    let descrUnidadAnt = this.props.idLista.descrUnidad

console.log(confirmaAct, this.props.permiteUpdate, this.props.permiteDelete)


    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          {this.props.idLista.descrPlanta} - {this.props.idLista.descrSeccion} - {this.props.idLista.descrEquipo} - {this.props.idLista.descrComponente} - {this.props.idLista.descrMecanismo}
        </button>
        {/* <div style={this.props.styles.backGr_2}> */}
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum,
              descrPlantaAnt, descrSeccionAnt, descrEquipoAnt, descrComponenteAnt, descrMecanismoAnt,
              codPlantaAnt, codSeccionAnt, codEquipoAnt, codComponenteAnt, codMecanismoAnt, 
              descrLubricanteAnt, descrAplicacionAnt, tipoFrecuenciaAnt, descrUnidadAnt):()=>{}}>
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "15%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código Planta</label>
                    <Form.Input autoComplete="off" name="codPlanta" id="codPlanta" value={this.props.permiteUpdate?argsDocum.codPlanta:this.props.idLista.codPlanta} onChange={this.handleChange} placeholder='Código Planta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codPlanta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Planta</label>
                    <Form.Input autoComplete="off" name="descrPlanta" id="descrPlanta" value={this.props.permiteUpdate?argsDocum.descrPlanta:this.props.idLista.descrPlanta} onChange={this.handleChange} placeholder='Descripción Planta' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrPlanta'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "15%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código Sección</label>
                    <Form.Input autoComplete="off" name="codSeccion" id="codSeccion" value={this.props.permiteUpdate?argsDocum.codSeccion:this.props.idLista.codSeccion} onChange={this.handleChange} placeholder='Código Sección' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codSeccion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Sección</label>
                    <Form.Input autoComplete="off" name="descrSeccion" id="descrSeccion" value={this.props.permiteUpdate?argsDocum.descrSeccion:this.props.idLista.descrSeccion} onChange={this.handleChange} placeholder='Descripción Sección' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrSeccion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
              </div>
            </div>
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "15%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código Equipo</label>
                    <Form.Input autoComplete="off" name="codEquipo" id="codEquipo" value={this.props.permiteUpdate?argsDocum.codEquipo:this.props.idLista.codEquipo} onChange={this.handleChange} placeholder='Código Equipo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codEquipo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Equipo</label>
                    <Form.Input autoComplete="off" name="descrEquipo" id="descrEquipo" value={this.props.permiteUpdate?argsDocum.descrEquipo:this.props.idLista.descrEquipo} onChange={this.handleChange} placeholder='Descripción Equipo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrEquipo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "15%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código Componente</label>
                    <Form.Input autoComplete="off" name="codComponente" id="codComponente" value={this.props.permiteUpdate?argsDocum.codComponente:this.props.idLista.codComponente} onChange={this.handleChange} placeholder='Código Componente' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codComponente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Componente</label>
                    <Form.Input autoComplete="off" name="descrComponente" id="descrComponente" value={this.props.permiteUpdate?argsDocum.descrComponente:this.props.idLista.descrComponente} onChange={this.handleChange} placeholder='Descripción componente' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrComponente'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
              </div>
            </div>

            <Divider inverted />

            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "15%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Código Mecanismo</label>
                    <Form.Input autoComplete="off" name="codMecanismo" id="codMecanismo" value={this.props.permiteUpdate?argsDocum.codMecanismo:this.props.idLista.codMecanismo} onChange={this.handleChange} placeholder='Código Mecanismo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'codMecanismo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Mecanismo</label>
                    <Form.Input autoComplete="off" name="descrMecanismo" id="descrMecanismo" value={this.props.permiteUpdate?argsDocum.descrMecanismo:this.props.idLista.descrMecanismo} onChange={this.handleChange} placeholder='Descripción Mecanismo' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrMecanismo'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                {/* <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Fabricante</label>
                    <Form.Input autoComplete="off" name="descrFabricante" id="descrFabricante" value={this.props.permiteUpdate?argsDocum.descrFabricante:this.props.idLista.descrFabricante} onChange={this.handleChange} placeholder='Descripción Fabricante' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrFabricante'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div> */}
                {/* <div className="column" style={{width: "15%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo Frecuencia</label>
                    <ListaTF styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div> */}
                <div className="column" style={{width: "20%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de frecuencia</label>
                    <ListaTF styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "35%"}}>
                  {/* <Form.Field>
                    <label style={this.props.styles.label}>Descripción Aplicación</label>
                    <Form.Input autoComplete="off" name="descrAplicacion" id="descrAplicacion" value={this.props.permiteUpdate?argsDocum.descrAplicacion:this.props.idLista.descrAplicacion} onChange={this.handleChange} placeholder='Descripción Aplicación' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrAplicacion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field> */}
                  <Form.Field>
                    <label style={this.props.styles.label}>Aplicación/Espesante</label>
                    <ListaAp list={this.props.list10} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>                
                </div>
              </div>
            </div>
            {/* <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "15%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Categ Lubricante</label>
                    <Form.Input autoComplete="off" name="categoriaLub" id="categoriaLub" value={this.props.permiteUpdate?argsDocum.categoriaLub:this.props.idLista.categoriaLub} onChange={this.handleChange} placeholder='Categ Lubricante' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'categoriaLub'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "35%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo Lubricante</label>
                    <Form.Input autoComplete="off" name="tipoLub" id="tipoLub" value={this.props.permiteUpdate?argsDocum.tipoLub:this.props.idLista.tipoLub} onChange={this.handleChange} placeholder='Tipo Lubricante' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'tipoLub'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo Grado</label>
                    <Form.Input autoComplete="off" name="tipoGrado" id="tipoGrado" value={this.props.permiteUpdate?argsDocum.tipoGrado:this.props.idLista.tipoGrado} onChange={this.handleChange} placeholder='Tipo Grado' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'tipoGrado'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Grado</label>
                    <Form.Input autoComplete="off" name="descrGrado" id="descrGrado" value={this.props.permiteUpdate?argsDocum.descrGrado:this.props.idLista.descrGrado} onChange={this.handleChange} placeholder='Descripción Grado' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrGrado'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
              </div>
            </div> */}
            <div className="ui three column stackable grid">
              <div className="row container">
                <div className="column" style={{width: "50%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Descripción Lubricante</label>
                    <Lista list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Cantidad Total</label>
                    {/* <Form.Input autoComplete="off" name="cantidadTotal" id="cantidadTotal" value={this.props.permiteUpdate?argsDocum.cantidadTotal:this.props.idLista.cantidadTotal} onChange={this.handleChange} placeholder='Cantidad Total' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'cantidadTotal'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} /> */}
                    <Form.Input type='number' step="0.001" min="0" autoComplete="off" name="cantidadTotal" id="cantidadTotal" value={this.props.permiteUpdate?argsDocum.cantidadTotal:this.props.idLista.cantidadTotal} onChange={this.handleChange} placeholder='Cantidad Total' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'oxidacion'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div>
                <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Unidad</label>
                    <ListaU list={this.props.list11} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>                
                {/* <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Unidad Frecuencia</label>
                    <Form.Input autoComplete="off" name="abrevUnidadTF" id="abrevUnidadTF" value={this.props.permiteUpdate?argsDocum.abrevUnidadTF:this.props.idLista.abrevUnidadTF} onChange={this.handleChange} placeholder='Unidad Frecuencia' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'abrevUnidadTF'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div> */}
              </div>
            </div>
            {/* <div className="ui three column stackable grid">
              <div className="row container"> */}

                {/* <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={this.props.styles.label}>Abreviatura Unidad</label>
                    <Form.Input autoComplete="off" name="abrevUnidad" id="abrevUnidad" value={this.props.permiteUpdate?argsDocum.abrevUnidad:this.props.idLista.abrevUnidad} onChange={this.handleChange} placeholder='Abreviatura Unidad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'abrevUnidad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                </div> */}
              {/* </div>
            </div> */}
 
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%"> 
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerPr2
